import { Contract, ContractTenant } from '../../../../../../common/validations'
import { isTerminationDisallowedBecauseOfPending } from '../../../../ContractChanges/utils/isTerminationDisallowedBecauseOfPending'

import { TerminateSuggestionAction } from 'views/ContractChanges/hooks/useTerminateSuggestions'

export const getValue = (
  contract: Contract,
  tenant: ContractTenant,
  terminateState: boolean
) => {
  const terminationDisallowedBecauseOfPending =
    isTerminationDisallowedBecauseOfPending(contract)

  const isCurrentTenant = tenant.id === contract.tenant.id

  const terminateTenant = (() => {
    if (!isCurrentTenant && !contract.tenant.isContractParty) return false

    return terminateState
  })()

  if (terminationDisallowedBecauseOfPending) {
    return TerminateSuggestionAction.PENDING
  }

  return terminateTenant
    ? TerminateSuggestionAction.TERMINATE
    : TerminateSuggestionAction.IN_EFFECT
}
